import { createContext } from "react"
import { ReadyState } from "react-use-websocket";

export interface IWebsocketState {
  connectionStatus: string
  readyState: number
  lastJsonMessage: any
  send: (action: string, jsonData: any) => void
  disconnect: () => void
}

export const defaultState: IWebsocketState = {
  connectionStatus: '',
  readyState: ReadyState.UNINSTANTIATED,
  lastJsonMessage: null,
  send: (action: string, jsonData: any) => console.log(action, jsonData),
  disconnect: () => {}
}

export const WebsocketContext = createContext<IWebsocketState>(defaultState)
